var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImcNormalWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23 52",
    style: {
      enableBackground: "new 0 0 23 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#105742;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21,31.6c0.9,0,1.7-0.7,1.8-1.7c0.1-1.6,0.1-3,0.1-4.3c0-6.8-1.1-10.5-2.5-12.8c-0.7-1.1-1.6-1.8-2.4-2.2 c-0.7-0.4-1.4-0.5-1.8-0.5c0,0-0.1,0-0.1,0H7.5c0,0-0.1,0-0.1,0c-0.4,0-1.1,0.1-1.8,0.5c-1.2,0.6-2.5,1.9-3.4,4.2 c-0.9,2.3-1.5,5.7-1.5,10.8c0,1.3,0,2.7,0.1,4.3c0.1,1,0.8,1.7,1.8,1.7c0,0,0.1,0,0.1,0c1-0.1,1.7-0.9,1.7-1.9 c-0.1-1.5-0.1-2.9-0.1-4.1c0-5.4,0.8-8.5,1.5-10.1v33.7C5.8,50.8,7,52,8.5,52c1.5,0,2.7-1.2,2.7-2.8V29h1v20.3 c0,1.5,1.2,2.8,2.7,2.8c1.5,0,2.7-1.2,2.7-2.8V15.6c0.1,0.3,0.3,0.6,0.4,1c0.6,1.8,1.2,4.6,1.1,9.1c0,1.2,0,2.6-0.1,4.1 c-0.1,1,0.7,1.8,1.7,1.9C20.9,31.6,21,31.6,21,31.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.5,8.9c2.5,0,4.4-2,4.4-4.4c0-2.5-2-4.4-4.4-4.4C9,0,7,2,7,4.4C7,6.9,9,8.9,11.5,8.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImcNormalWhite);
export default __webpack_public_path__ + "static/media/IMC_Normal_white.1964085f.svg";
export { ForwardRef as ReactComponent };